import type { FC } from "react";

import { t } from "i18n/i18n";
import { ConfirmationDialog } from "mds/components/ConfirmationDialog";

type AssessmentExitDialogProps = {
  open: boolean;
  onClose: () => void;
  count: number;
  total: number;
  published: boolean;
  onConfirmExit: () => void;
};

export const AssessmentExitDialog: FC<AssessmentExitDialogProps> = ({
  open,
  onClose,
  onConfirmExit,
  count,
  total,
  published,
}) => (
  <ConfirmationDialog
    cancelButtonKind="accent"
    cancelButtonText={t("assessment.resume_assessment")}
    confirmButtonKind="tertiary"
    confirmButtonText={t("assessment.finish_later")}
    description={t("assessment.assessment_in_progress_modal.description", {
      context: published ? "published" : "unpublished",
      count,
      total,
    })}
    open={open}
    title={t("assessment.assessment_in_progress_modal.title")}
    reverseButtons
    onClose={onClose}
    onConfirm={onConfirmExit}
  />
);
